<template>
    <v-dialog
    v-model="shown"
    persistent
    max-width="500"
  >
    <v-card>
      <v-card-title class="headline">
        Spremeni račun
      </v-card-title>

      <v-card-text>
        <!-- <v-row>
          <v-col>
            <h3>
              Klient
            </h3>
          </v-col>
        </v-row> -->
        <v-row>
          <v-col>
            <SettingsCard
              icon="far fa-comment"
              title="Opomba"
              :subtitle="commentSubtitle"
              @click="openCommentPopup"
            />
          </v-col>
          <v-col>
            <SettingsCard
              icon="fas fa-user-tie"
              title="Klient"
              :subtitle="clientSubtitle"
              @click="openAddClientPopup"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <h3>Plačilno sredstvo</h3>
          </v-col>
        </v-row>
        <v-row class="payment-types paymentOptions" style="margin-bottom: 20px; margin-left: 0; border-bottom: 1px solid rgb(134, 131, 131);">
          <v-col class="col-12 padded-slot" v-for="type in paymentTypes" :key="type.id">
            <SplitPaymentTypesForm
              :ref="type.id+'FORM'"
              :text="type.name"
              :currentValue="type.value ? Math.round((type.value) * 1e2) / 1e2 : null"
              :valueLeft="parseFloat(paymentLeft).toFixed(2)"
              :type="type.id"
              :currentTrrPaymentId="currentTrrPaymentId"
              class="payment-select-btn"
              @togglePaymentType="togglePaymentType(type.name, type.id, type.print_payment_type, type.sort_order, $event)"
              @clearCurrent="clearPaymentTypesSpecific(type.id, $event)"
              @click="hideMobileInput"
              @openPopup="openPopup"
            />
          </v-col>
        </v-row>
        <SplitPaymentTypesForm
          text="RAZLIKA"
          :currentValueString="currentValueFormat"
          class="payment-select-btn lastOne"
          @clear="clearPaymentTypes"
        />
        <div class="bottom-actions-wrapper">
          <v-row v-if="invoice">
            <Total v-if="invoice" ref="popupreceiptsettingstotal" :partialList="partialySelectedArticles" :editMode="true" :payment="invoiceAmount" />
          </v-row>
        </div>
        <div class="row bottom-actions">
          <span style="margin-top: auto; position: relative; display: flex; justify-content: flex-end; width: 100%;" @mouseenter="printHover = true" @mouseleave="printHover = false">
            <span class="error-msg" v-if="printHover && !readyToPrint && !payments[currentTrrPaymentId.id]" @click="printHover = false">
              Izbrati morate plačilno sredstvo
            </span>
            <span class="error-msg" v-if="printHover && !readyToPrint && !client && payments[currentTrrPaymentId.id]" @click="printHover = false">
              Za negotovinsko plačilo mora biti dodan klient
            </span>
            <v-btn text type="button" class="float-right mr-4" style="background-color: #ED7F78; color: #fff;" @click="cancel">Prekliči</v-btn>
            <v-btn text :disabled="!readyToPrint" type="button" class="float-right mr-4" style="background-color: #0F998E; color: #fff!important;" @click="save">Shrani</v-btn>
          </span>
        </div>
      </v-card-text>
    </v-card>

    <PopupPaymentOptionsQuantity
      ref="popupArticlePriceAndQuantity"
    />

    <PopupComment
      ref="popupaddcomment"
      :comment="comment"
      @commentAdd="addComment"
    />

    <PopupAddClient
      ref="popupAddClient"
      @removeBuyer="removeBuyer"
      @save="selectClient"
    />
  </v-dialog>
</template>

<script>
function number_test(n) { return (n - Math. floor(n)) !== 0 } // eslint-disable-line
import { mapActions } from 'vuex'
import { objectToArray } from '@/utils/object'
import SplitPaymentTypesForm from './SplitPaymentTypesForm.vue'
import PaymentMethodCard from './PaymentMethodCard'
import PopupAddClient from './PopupAddClient'
import PopupPaymentOptionsQuantity from './PopupPaymentOptionsQuantity'
import SettingsCard from './SettingsCard'
import PopupComment from './PopupAddComment.vue'
import Total from './Total'

export default {
  components: {
    SplitPaymentTypesForm,
    SettingsCard,
    PopupComment,
    PaymentMethodCard,
    PopupAddClient,
    PopupPaymentOptionsQuantity,
    Total
  },
  props: {
    /* invoice: {
      required: true,
      validator: prop => typeof prop === 'object' || prop === null
    }, */
    /* paymentTypes: {
      required: true,
      type: Array
    },
    inivoicePaymentTypeId: {
      required: true,
      type: Number
    } */
  },
  data () {
    return {
      selectedTypeId: 0,
      payments: {},
      printHover: false,
      partialySelectedArticles: null,
      currentTrrPaymentId: null,
      hideOnInput: false,
      paymentLeft: 0,
      initialLeft: 0,
      invoice: null,
      comment: null,
      paymentType: null,
      client: null,
      shown: false
    }
  },
  computed: {
    invoiceAmount () {
      if (this.invoice) {
        if (this.invoice.payment_amount) {
          return this.invoice.payment_amount
        } else {
          return 0
        }
      }
      return 0
    },
    clientSubtitle () {
      if (!this.client) {
        return 'Ni klienta'
      }
      const name = this.client.name
      return name.length > 48 ? name.substring(0, 45) + '...' : name
    },
    commentSubtitle () {
      if (!this.comment) {
        return 'Ni opombe'
      }
      return 'Opomba dodana'
    },
    readyToPrint () {
      if (!this.payments) return false
      if (Number(this.paymentLeft) > 0) return false
      if (Number(this.paymentLeft) < 0) return false
      const noCashPayment = Object.values(this.payments).find(type => type.payment_type === this.currentTrrPaymentId.id)
      if (!this.client && noCashPayment) return false
      return true
    },
    invoiceHasClient () {
      if (this.client) return true
      return false
      // return this.invoice !== null && this.invoice.client && this.invoice.client !== null
    },
    paymentTypes () {
      console.log(this.$store.state.paymentTypes.items)
      return objectToArray(this.$store.state.paymentTypes.items).filter(type => type.is_visible)
    },
    currentValueFormat () {
      var accurate = this.paymentLeft
      if (typeof (accurate) === 'string') {
        accurate = accurate.replace('.', ',')
      } else {
        if (number_test(this.paymentLeft)) { // eslint-disable-line
          accurate = `${(this.paymentLeft).toFixed(2).replace('.', ',')}`
        } else {
          accurate = `${(this.paymentLeft).toFixed(2).replace('.', ',')}`
        }
      }
      // return `${(this.paymentLeft / 100).toFixed(2).replace('.', ',')}`
      return accurate
    },
  },
  methods: {
    ...mapActions('invoices', ['addBuyerInfo']),
    async openPopup (item) {
      const returnedQuant = await this.$refs.popupArticlePriceAndQuantity.open(item)
      if (returnedQuant) {
        this.$refs[`${returnedQuant.id}FORM`][0].value = returnedQuant.fina
      } else {
        this.$emit('error')
      }
      // if (reset) reset()
    },
    addComment (comment) {
      console.log('com: ', comment)
      this.comment = comment
    },
    togglePaymentType (name, type, paymentType, sortOrder, value) {
      if (value > 0) {
        this.payments[type] = {
          payment_type: type,
          amount: value,
          print_payment_type: paymentType,
          sortOrder,
          payment_type_name: name,

          studentAbonma: name.toLowerCase().includes('štud'),
        }
      }
      // var tempLeft = dineroToFloat(this.$refs.popupreceiptsettingstotal.correctCartSum)
      var tempLeft = this.invoice.payment_amount
      for (const typeId of Object.values(this.payments)) {
        tempLeft -= typeId.amount
      }
      this.paymentLeft = Math.round(tempLeft * 1e2) / 1e2
    },
    clearPaymentTypesSpecific (id, val) {
      this.$refs[`${id}FORM`][0].value = 0
      // this.$refs[`${id}FORM`][0].previousLastValue = 0
      const elel = this.paymentLeft + parseFloat(val)
      delete this.payments[id]
      this.paymentLeft = elel
      this.initialLeft = elel
    },
    clearPaymentTypes () {
      for (const type of Object.values(this.payments)) {
        if (this.payments[type.payment_type]) {
          this.$refs[`${type.payment_type}FORM`][0].value = 0
          // this.$refs[`${type.payment_type}FORM`][0].previousLastValue = 'da'
          this.$refs[`${type.payment_type}FORM`][0].selected = false
        } // else {
        // this.$refs[`${type.payment_type}FORM`][0].selected = false
        // }
      }
      this.payments = {}
      this.paymentLeft = this.invoice.payment_amount
    },
    selectType (id) {
      this.selectedTypeId = id
    },
    save () {
      /* let selectedPaymentType = null
      if (this.inivoicePaymentTypeId !== this.selectedTypeId) {
        selectedPaymentType = this.paymentTypes.find(t => t.id === this.selectedTypeId)
      }
      else {
        this.$emit('changeInvoice', { paymentType: selectedPaymentType, client: null })
        this.shown = false
      } */
      console.log('makakade: ', this.client)
      if (this.client !== null) {
        this.addBuyerInfo(this.client)
          .then(client => {
            this.$emit('changeInvoice', {
              client: client,
              paymentType: this.paymentType,
              comment: this.comment,
              payments:
              Object.values(this.payments).reduce((reducePaymentTypesArray, current) => {
                reducePaymentTypesArray.push({
                  payment_type: current.payment_type,
                  amount: current.amount,
                  print_payment_type: current.print_payment_type,
                  payment_type_name: current.payment_type_name,
                  sortOrder: current.sortOrder,
                })
                return reducePaymentTypesArray
              }, []).sort((a, b) => a.sortOrder - b.sortOrder) })
              this.cancel()
              this.shown = false
          })
          .catch(() => {
            this.shown = false
          })
      } else {
        this.$emit('changeInvoice', {
          client: null,
          paymentType: this.paymentType,
          comment: this.comment,
          payments:
          Object.values(this.payments).reduce((reducePaymentTypesArray, current) => {
            reducePaymentTypesArray.push({
              payment_type: current.payment_type,
              amount: current.amount,
              print_payment_type: current.print_payment_type,
              payment_type_name: current.payment_type_name,
              sortOrder: current.sortOrder,
            })
            return reducePaymentTypesArray
          }, []).sort((a, b) => a.sortOrder - b.sortOrder) })
          this.cancel()
          this.shown = false
      }
    },
    remove () {
      this.shown = false
    },
    cancel () {
      this.client = null
      this.paymentType = null
      for (const type of Object.values(this.payments)) {
        this.$refs[`${type.payment_type}FORM`][0].value = 0
        this.$refs[`${type.payment_type}FORM`][0].selected = false
        console.log('resync form: ', this.$refs[`${type.payment_type}FORM`][0].value)
        // this.$refs[`${type.payment_type}FORM`][0].reset()
      }
      this.shown = false
    },
    open ({ client, paymentType, invoice }) {
      this.invoice = invoice
      this.client = client || null
      if (paymentType) {
        this.paymentType = this.paymentTypes.find(type => type.name.toLowerCase() === paymentType.toLowerCase())
      }
      this.currentTrrPaymentId = this.paymentTypes.find(type => type.print_payment_type === 2)
      this.partialySelectedArticles = invoice.articles
      this.comment = invoice.comment
      this.payments = {}
      this.paymentLeft = 0
      this.initialLeft = 0
      // this.selectedTypeId = this.inivoicePaymentTypeId
      console.log('inv: ', invoice.payments, this.payments)
      if (invoice.payments) {
        for (const pay of invoice.payments) {
          this.payments[pay.payment_type] = pay
          setTimeout(() => {
            this.$refs[`${pay.payment_type}FORM`][0].value = pay.amount
          })
        }
      }
      /* if (this.invoiceHasClient) {
        this.client = this.invoice.buyerInfo
      } */
      this.shown = true
    },
    openAddClientPopup () {
      this.$refs.popupAddClient.open()
    },
    openCommentPopup () {
      this.$refs.popupaddcomment.open()
    },
    removeBuyer () {
      this.client = null
    },
    selectClient (client) {
      this.client = client
    }
  }
}
</script>

<!-- <style lang="scss" scoped>
.payment-types {
  max-height: calc(80vh - 120px);
  overflow: auto;
}
</style> -->

<style lang="scss" scoped>
  .error-msg {
    position: absolute;
    top: -70px;
    // left: 180px;
    right: 0px;
    background: white;
    padding: 10px;
    border: 1px solid lightgray;
    border-radius: 10px;
    color: red;
    z-index: 100;
    width: 200px;
  }

  @media (min-width: 375px) {
    .linebreak {
      display: none !important;
    }
    .row.paymentOptions {
      // border-bottom: none !important;
    }
  }

  @media (min-width: 1024px) {
    .row.paymentOptions {
      // border-bottom: none !important;
      // max-height: 200px;
    }

    .linebreak {
      display: none;
    }

    .paymentCurrentDifference {
      height: 51px !important;
      width: 100% !important;
      padding: 0 !important;
      margin-top: 5px;
    }
  }

  .paymentCurrentDifference {
    height: 51px !important;
    width: 100% !important;
    padding: 0 !important;
    margin-top: 5px;
  }

  .q-card {
    display: flex !important;
    flex-direction: column !important;
    width: 800px;
    max-width: 90vw;
  }

  .suma {
    // bottom: 80px !important;
    margin-left: 0 !important;
    .total {
      width: 100%;
      margin-left: 0 !important;
    }
  }
  .label {
    font-size: 16px;
    color: gray;
    margin-bottom: 10px;
  }
  .title {
    font-size: 16px;
  }
  .close {
    color: red;
  }
  .popup-header {
    height: 70px;
  }
  .popup-body {
    width: 780px;
    padding: 0px 20px 20px 20px;
    max-height: calc(100vh - 200px);
    overflow-y: auto;

    .row {
      margin-left: 20px;
      &.title {
        margin: 20px 0;
      }
    }

    .payment-select-column {
      flex-direction: column;
    }

    .payment-select-btn {
      width: 100%;
      height: fit-content;
      line-height: 1 !important;
    }
  }

  .bottom-actions-wrapper {
    margin-bottom: 0;
    margin-top: 20px;
    position: relative;
    bottom: 0;
    padding: 0 18px !important;
    .bottom-actions {
      margin-left: 0;
      // position: absolute;
      position: relative;
      // height: 51px;
      // position: fixed;
      // top: calc(100vh - 100px);
      width: calc(100vw - 40px);
      bottom: 7px;
      // left: 20px;
    }
  }

  .popup-footer {
    height: 60px;
  }
  .padded-slot {
    padding: 2px 4px;
  }

  .hr-breakpoint-mobile {
    .lastOne {
      margin-bottom: 20px !important;
    }

    .suma {
    // position: sticky !important;
    // bottom: 47px !important;
    top: 5px;
    margin-left: 0 !important;
    .total {
      width: 100%;
      margin-left: 0 !important;
    }
  }

  .q-card {
    width: 100vw;
    max-width: 100vw;
  }

    .q-dialog__inner .q-card {
      width: 100vw;
    }
    .popup-body {
      position: relative;
      width: 100vw;
      height: calc(100vh - 188px) !important;
      // height: 100%;
      max-height: calc(100vh - 188px) !important;
      overflow-y: auto !important;
      /* width: 100vw;
      max-height: calc(100vh - 130px) !important; */
    }

    .bottom-actions-wrapper {
        position: fixed;
        bottom: 0;
        padding: 0 18px !important;

        .bottom-actions {
        margin-left: 0;
        // position: absolute;
        position: relative;
        // height: 51px;
        // position: fixed;
        // top: calc(100vh - 100px);
        width: calc(100vw - 40px);
        bottom: 7px;
        // left: 20px;
      }
    }

    .q-card {
      position: relative;

      .popup-footer {
        position: absolute;
        bottom: 0;
        right: 0;
      }
    }

    .padded-slot {
      padding: 0px 2px;
    }
  }
</style>
